import { Box } from 'braid-design-system';
import React, { type ReactNode } from 'react';

import * as styles from './style.css';

type Alignment = 'start' | 'end' | 'centre' | 'leftCentre';

interface Props {
  alignment?: Alignment;
  maxHeight?: number;
  maxWidth?: number;
  minHeight?: number;
  minWidth?: number;
  height?: number | string;
  width?: number | string;
  children: ReactNode;
}

const LayoutBox = (props: Props) => {
  const alignmentMap = {
    leftCentre: styles.leftCentre,
    centre: styles.centre,
    start: styles.start,
    end: styles.end,
  };
  const alignment = props.alignment ? alignmentMap[props.alignment] : '';
  return (
    <Box className={alignment}>
      <Box
        style={{
          maxHeight: props.maxHeight,
          maxWidth: props.maxWidth,
          minHeight: props.minHeight,
          minWidth: props.minWidth,
          height: props.height,
          width: props.width,
          padding: 0,
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
};

export default LayoutBox;
